import { atom } from 'recoil';

export const dataUserBeneForm = atom({
  key: 'dataUserBeneForm',
  default: undefined,
});
